import React, { useEffect } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { CustomTextField } from "../../../../../partials/content/Forms";
import {
  onPreventEnterSubmitting,
  setObject,
} from "../../../../../utils/utils";
import { DialogActions, FormControlLabel, Switch } from "@material-ui/core";
import { saveCustomerContact } from "../../../../../services/sales/customerService";
import Swal from "sweetalert2";
import { Card } from "react-bootstrap";
import store from "../../../../../store/store";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
const CustomerContactForm = ({
  customerID,
  contact,
  action,
  onCloseDialog,
  onConfirmSave,
}) => {
  const { socket } = useGlobalData();
  let contactData = {
    ID: 0,
    customerID: customerID,
    contactName: "",
    position: "",
    contactPhone: "",
    contactEmail: "",
    password: "",
    standardFlag: false,
    locked: false,
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  };
  if (contact && contact.ID > 0) {
    contactData = {
      ID: contact.ID,
      customerID: customerID,
      contactName: contact.contactName,
      position: contact.position,
      contactPhone: contact.contactPhone,
      contactEmail: contact.contactEmail,
      password: contact.password,
      standardFlag: contact.standardFlag,
      locked: contact.locked,
      CreatedAt: contact.CreatedAt,
      UpdatedAt: contact.UpdatedAt,
      createdBy: contact.createdBy,
      updatedBy: contact.updatedBy,
    };
  }

  const contactFormSchema = yup.object().shape({
    customerID: yup.number(),
    contactName: yup
      .string()
      .required("Contact Name is required")
      .max(255, "Contact Name maximum characters is 255"),
    position: yup
      .string()
      .required("Position is required")
      .max(50, "Position maximum characters is 50"),
    contactPhone: yup
      .string()
      .required("Phone Number is required")
      .matches(
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
        "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
      )
      .max(50, "Phone Number maximum characters is 50"),
    contactEmail: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .required("Email is required")
      .max(50, "Email maximum characters is 50"),
  });

  useEffect(() => {
    const { auth } = store.getState();

    if (contact && contact.ID > 0) {
      setObject(socket, "lock", contact.ID, "CUCO", auth.user)
        .then((response) => {})
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (contact && contact.ID > 0) {
        setObject(socket, "release", contact.ID, "CUCO", auth.user);
      }
    };
  }, []);

  return (
    <Formik
      initialValues={contactData}
      validationSchema={contactFormSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.customerID = parseFloat(values.customerID);
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Customer Contact ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveCustomerContact(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-th-large"></i>
                  <span>
                    <strong>Customer Contact Basic Info</strong>
                  </span>
                </Card.Header>
                <Card.Body>
                  <CustomTextField
                    label="Contact Name"
                    inputType="text"
                    propertyName="contactName"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    values={values}
                    touched={touched}
                    errors={errors}
                    endAdornment={{
                      readOnly:
                        contactData.standardFlag || action === "detail"
                          ? true
                          : false,
                    }}
                    disabled={
                      contactData.standardFlag || action === "detail"
                        ? true
                        : false
                    }
                    size="small"
                  />
                  <CustomTextField
                    label="Position"
                    inputType="text"
                    propertyName="position"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    values={values}
                    touched={touched}
                    errors={errors}
                    endAdornment={{
                      readOnly:
                        contactData.standardFlag || action === "detail"
                          ? true
                          : false,
                    }}
                    disabled={
                      contactData.standardFlag || action === "detail"
                        ? true
                        : false
                    }
                    size="small"
                  />
                  <CustomTextField
                    label="Phone Number"
                    inputType="text"
                    propertyName="contactPhone"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    values={values}
                    touched={touched}
                    errors={errors}
                    endAdornment={{
                      readOnly:
                        contactData.standardFlag || action === "detail"
                          ? true
                          : false,
                    }}
                    disabled={
                      contactData.standardFlag || action === "detail"
                        ? true
                        : false
                    }
                    size="small"
                  />
                  <CustomTextField
                    label="Email"
                    inputType="email"
                    propertyName="contactEmail"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    values={values}
                    touched={touched}
                    errors={errors}
                    endAdornment={{
                      readOnly:
                        contactData.standardFlag || action === "detail"
                          ? true
                          : false,
                    }}
                    disabled={
                      contactData.standardFlag || action === "detail"
                        ? true
                        : false
                    }
                    size="small"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        name="locked"
                        checked={values.locked}
                        onChange={handleChange}
                        value={values.locked}
                        color="primary"
                        disabled={action === "detail" ? true : false}
                      />
                    }
                    label="Lock Customer Portal Access"
                    className="my-2"
                  />
                </Card.Body>
              </Card>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            {action === "create" || action === "edit" ? (
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
                disabled={isSubmitting}
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            ) : null}
          </DialogActions>
        </form>
      )}
    </Formik>
  );
};

export default CustomerContactForm;
